import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageDomainService {

  constructor(private _httpClient: IesHttpClient) {
  }

  getKoala(urlParams: any) {
    return this._httpClient.get(AppUrl.getKoala, urlParams);
  }

  getDomain(urlParams: any) {
    return this._httpClient.get(AppUrl.domain, urlParams);
  }

  postDomain(params: any) {
    return this._httpClient.post(AppUrl.domain, params);
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-domain/adm-manage-domain.service.ts